<template>
  <div @contextmenu.prevent="">
    <div class="box breadcrumb is-medium is-centered has-bullet-separator is-fullwidth" aria-label="breadcrumbs">
      <ul>
        <li><router-link :to="{ name: 'chapter', params: { novelId: this.novelId, chapterId: this.prevChapter } }" v-show="innerHTML && chapterNumber > 1">
            <span class="icon is-small"><i class="fas fa-book" aria-hidden="true"></i></span>
            ตอนก่อนหน้า</router-link>
        </li>
        <li><router-link :to="`/novel/${novelId}`">
            <span class="icon is-small"><i class="fas fa-home" aria-hidden="true"></i></span>
            สารบัญ</router-link>
        </li>
        <li><router-link :to="{ name: 'chapter', params: { novelId: this.novelId, chapterId: this.nextChapter } }" v-show="innerHTML">
            <span class="icon is-small"><i class="fas fa-book" aria-hidden="true"></i></span>
            ตอนถัดไป</router-link>
        </li>
      </ul>
    </div>

    <b-loading :active="isLoading"></b-loading>
    <div class="container box" :class="theme">
      <p class="has-text-centered is-size-5" v-if="$root.isImmortal">ท่านเป็นผู้บุกเบิกขั้นเซียนอมตะ สามารถอ่านนิยายได้ทุกเรื่องและทุกตอนของเว็บไซต์นี้</p>
      <p class="has-text-centered" v-else>ท่านมียอดสนับสนุน นิยายเรื่อง {{ novel.name }} จำนวน {{ donateTotal }} บาท </p>
      <p class="has-text-centered" v-show="novel.chapterFree">สามารถอ่านได้ถึงตอนที่ {{ numberCanRead(value) }}</p>
    </div>
    <div class="container box" v-if="!isLoading && innerHTML" :class="theme" :style="contentStyle">
      <b-tabs type="is-toggle is-centered" v-model="themeIndex">
        <b-tab-item label="Normal theme" icon="sun"></b-tab-item>
        <b-tab-item label="Dark theme" icon="moon"></b-tab-item>
        <b-tab-item label="Grey theme" icon="moon"></b-tab-item>
        <b-tab-item label="Bright theme" icon="sun"></b-tab-item>
        <b-field position="is-centered">
          <a class="button is-primary is-medium" @click="fontSize++">เพิ่มตัวอักษร</a>
          <a class="button is-primary is-medium" @click="fontSize--">ลดตัวอักษร</a>
        </b-field>
      </b-tabs>
      <div class="content unselectable" v-html="innerHTML">
      </div>
    </div>
    <div v-else-if="error" class="container box">
      {{ error }}
    </div>
    <!-- <div v-if="!isLoading && innerHTML"> -->
    <div>
      <div class="container box">
        <h2 class="subtitle">แสดงความคิดเห็นของคุณ</h2>
        <article class="media">
          <figure class="media-left" v-show="user.photoURL">
            <p class="image is-64x64">
              <img :src="user.photoURL">
            </p>
          </figure>
          <div class="media-content">
            <div v-if="!user.displayName">
              <b-field>
                <b-input v-model="myComment.displayName" placeholder="ชื่อ" :disabled="isCommentLoading"></b-input>
              </b-field>
              <br>
            </div>
            <div v-else>
              <b-field :label="myComment.displayName"></b-field>
            </div>
            <b-field>
              <b-input type="textarea" v-model="myComment.text" placeholder="อ่านตอนนี้แล้วเป็นยังไงบ้าง?..." :disabled="isCommentLoading"></b-input>
            </b-field>
            <b-field>
              <button class="button is-primary"
              :class="{ 'is-loading': isCommentLoading }"
              @click="postComment(myComment)"
              :disabled=" myComment.text == '' || myComment.displayName == '' ">ส่งความคิดเห็น</button>
            </b-field>
          </div>
        </article>
      </div>
      <div class="container box">
        <div v-if="commentsSorted.length === 0">
          <h2 class="subtitle">อ่านตอนนี้แล้วสนุกไหม?...ลองแสดงความคิดเห็นร่วมกับคนอื่นดูสิ</h2>
        </div>
        <div v-else>
          <h2 class="subtitle">ความคิดเห็นทั้งหมด</h2>
          <div v-for="comment in commentsSorted" :key="comment['.key']">
            <hr>
            <article class="media">
              <figure class="media-left" v-show="comment.photoURL">
                <p class="image is-64x64">
                  <img :src="comment.photoURL">
                </p>
              </figure>
              <div class="media-content">
                <div class="content">
                  <p>
                    <strong>{{ comment.displayName }}</strong><small> {{ dateFromNow(comment.date) }}</small>
                    <br>
                    {{ comment.text }}
                  </p>
                </div>
                <nav class="level is-mobile">
                  <div class="level-left">
                    <div class="level-item">
                      <button class="button is-small" @click="toggleReply(comment)">
                        <b-icon pack="fas" icon="reply"></b-icon>
                      </button>
                    </div>
                    <div class="level-item">
                      <button class="button is-small" @click="toggleHeart(comment)">
                        <div v-if="comment.hearts.length > 0">
                          <span>{{ comment.hearts.length }}</span>
                          <b-icon type="is-emerald" pack="fas" icon="heart"></b-icon>
                        </div>
                        <div v-else>
                          <b-icon pack="fas" icon="heart"></b-icon>
                        </div>
                      </button>
                    </div>
                  </div>
                </nav>
                <div v-for="nested in comment.comments" :key="nested['.key']">
                  <article class="media">
                    <figure class="media-left" v-show="nested.photoURL">
                      <p class="image is-64x64">
                        <img :src="nested.photoURL">
                      </p>
                    </figure>
                    <div class="media-content">
                      <div class="content">
                        <p>
                          <strong>{{ nested.displayName }}</strong><small> {{ dateFromNow(nested.date) }}</small>
                          <br>
                          {{ nested.text }}
                        </p>
                      </div>
                      <nav class="level is-mobile">
                        <div class="level-left">
                          <div class="level-item">
                            <button class="button is-small" @click="toggleHeart(nested)">
                              <div v-if="nested.hearts.length > 0">
                                <span>{{ nested.hearts.length }}</span>
                                <b-icon type="is-emerald" pack="fas" icon="heart"></b-icon>
                              </div>
                              <div v-else>
                                <b-icon pack="fas" icon="heart"></b-icon>
                              </div>
                            </button>
                          </div>
                        </div>
                      </nav>
                    </div>
                    <div class="media-right" v-show="nested.uid != null && nested.uid == user.uid">
                      <button class="delete" @click="removeComment(nested)"></button>
                    </div>
                  </article>
                </div>
                <article class="media" v-show="isReplyingComment == comment['.key']">
                  <figure class="media-left" v-show="user.photoURL">
                    <p class="image is-64x64">
                      <img :src="user.photoURL">
                    </p>
                  </figure>
                  <div class="media-content">
                    <div v-if="!user.displayName">
                      <b-field>
                        <b-input v-model="myComment.displayName" placeholder="ชื่อ" :disabled="isCommentLoading"></b-input>
                      </b-field>
                      <br>
                    </div>
                    <div v-else>
                      <b-field :label="myComment.displayName"></b-field>
                    </div>
                    <b-field>
                      <b-input type="textarea" v-model="myComment.text" placeholder="ตอบกลับข้อความด้านบน..." :disabled="isCommentLoading"></b-input>
                    </b-field>
                    <b-field>
                      <button class="button is-primary"
                      :class="{ 'is-loading': isCommentLoading }"
                      @click="postComment(myComment, comment)"
                      :disabled=" myComment.text == '' || myComment.displayName == '' ">ส่งความคิดเห็น</button>
                    </b-field>
                  </div>
                </article>
              </div>
              <div class="media-right" v-show="comment.uid != null && comment.uid == user.uid">
                <button class="delete" @click="removeComment(comment)"></button>
              </div>
            </article>
          </div>
        </div>
      </div>
      <div class="container">
      </div>
    </div>
    <div class="box breadcrumb is-medium is-centered has-bullet-separator is-fullwidth" aria-label="breadcrumbs">
      <ul>
        <li><router-link :to="{ name: 'chapter', params: { novelId: this.novelId, chapterId: this.prevChapter } }" v-show="innerHTML && chapterNumber > 1">
            <span class="icon is-small"><i class="fas fa-book" aria-hidden="true"></i></span>
            ตอนก่อนหน้า</router-link>
        </li>
        <li><router-link :to="`/novel/${novelId}`">
            <span class="icon is-small"><i class="fas fa-home" aria-hidden="true"></i></span>
            สารบัญ</router-link>
        </li>
        <li><router-link :to="{ name: 'chapter', params: { novelId: this.novelId, chapterId: this.nextChapter } }" v-show="innerHTML">
            <span class="icon is-small"><i class="fas fa-book" aria-hidden="true"></i></span>
            ตอนถัดไป</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { db } from '@/firebase.config'
import { get, commit } from 'vuex-pathify'
import firebase from '@firebase/app'
import * as moment from 'moment'
import 'moment/locale/th'

export default {
  props: {
    novelId: String,
    chapterId: String
  },
  metaInfo () {
    return {
      title: this.title,
      meta: [
        { property: 'og:title', content: this.title },
        { property: 'og:description', content: this.novel['name-en'] + '' + this.novel['name-th'] },
        { property: 'og:image', content: this.novel['image-cover'] },
        { property: 'og:url', content: this.$route.fullPath }
      ]
    }
  },
  firestore () {
    return {
      comments: db.collection(`chapters/${this.novelId}-${this.chapterId}/comments`)
    }
  },
  data () {
    return {
      value: {},
      error: '',
      theme: '',
      themeIndex: 0,
      fontSize: 13,
      contentStyle: {
        fontSize: '13px'
      },
      novel: this.$root.novels.find(novel => novel.id === this.novelId),
      comments: [],
      myComment: {
        text: '',
        displayName: ''
      },
      isReplyingComment: '',
      isCommentLoading: false
    }
  },
  beforeRouteEnter (to, from, next) {
    commit('SET_LOADING', true)
    var ref = db.collection('chapters')
      .where('novel_id', '==', to.params.novelId)
      .where('chapter', '==', parseInt(to.params.chapterId))
      .where('status', '==', 'public')
    ref.get().then((snapshot) => {
      if (snapshot.empty) {
        next(vm => vm.setChapter('ตอน ' + to.params.chapterId + ' ยังไม่มีในระบบ'))
      } else {
        next(vm => vm.setChapter(null, snapshot.docs[0].data()))
      }
    }).catch(error => {
      next(vm => vm.setChapter(error, null))
    })
  },
  // when route changes and this component is already rendered,
  // the logic will be slightly different.
  beforeRouteUpdate (to, from, next) {
    commit('SET_LOADING', true)
    this.value = {}
    var ref = db.collection('chapters')
      .where('novel_id', '==', to.params.novelId)
      .where('chapter', '==', parseInt(to.params.chapterId))
      .where('status', '==', 'public')
    ref.get().then((snapshot) => {
      if (snapshot.empty) {
        this.setChapter('ตอน ' + to.params.chapterId + ' ยังไม่มีในระบบ')
      } else {
        this.setChapter(null, snapshot.docs[0].data())
      }
      next()
    }).catch(error => {
      this.setChapter(error, null)
      next(false)
    })
  },
  computed: {
    user: get('user'),
    isLoading: get('loading'),
    title () { return (this.novel ? this.novel.name : '') + ' ' + 'ตอนที่ ' + this.chapterId },
    chapterNumber () { return parseInt(this.chapterId) },
    nextChapter () { return `${this.chapterNumber + 1}` },
    prevChapter () { return `${this.chapterNumber - 1}` },
    innerHTML () {
      if ((this.value['post_content']) && (!this.novel.isHidden)) {
        return this.value['post_content'].replace(/(?:\r\n|\r|\n)/g, '<br />')
      }
      return null
    },
    donateTotal () {
      var completedPayments = this.$root.payments.filter(payment => {
        const id = payment['novel_id'] === undefined ? 'xian-ni' : payment['novel_id']
        return payment.status === 'completed' && id === this.novelId
      })
      if (completedPayments.length > 0) {
        return completedPayments.map(payment => parseInt(payment.amount)).reduce((prev, next) => prev + next)
      }
      return 0
    },
    commentsSorted () {
      return this.comments
        .slice()
        .sort((a, b) => a.date.toDate() - b.date.toDate())
        .reduce((prev, current) => {
          if (current.nestedComment) {
            var nested = prev.find(value => value['.key'] === current.nestedComment)
            if (!nested) {
              return prev
            }
            if (!nested.comments) {
              nested.comments = []
            }
            var already = nested.comments.find(value => value['.key'] === current['.key'])
            if (already) {
              return prev
            } else {
              nested.comments.push(current)
            }
          } else {
            prev.push(current)
          }
          return prev
        }, [])
    }
  },
  methods: {
    canRead (read) {
      if (this.$root.isImmortal) {
        return true
      }
      if (!this.novel) {
        return false
      }
      if (!this.novel.chapterFree) {
        return true
      }
      if (read.chapter <= this.novel.chapterFree) {
        return true
      }
      if (read.chapter <= this.numberCanRead(read)) {
        return true
      }
      return false
    },
    numberCanRead (read) {
      const priceRate = this.novel.chapterPerPrice === undefined ? 1 : this.novel.chapterPerPrice
      return parseInt(this.novel.chapterFree) + parseInt(this.donateTotal > 0 ? (this.donateTotal / priceRate) : 0)
    },
    messageForRead (read) {
      return `ท่านมียอดสนับสนุน ${this.donateTotal} บาท สามารถอ่านได้ถึงตอนที่ ${this.numberCanRead(read)} เท่านั้นและไม่สามารถอ่านตอน ${read.chapter} ได้ กรุณาเพิ่มยอดสนับสนุนสะสมเพื่ออ่านตอนนี้`
    },
    setChapter (err, chapter) {
      if (err) {
        this.error = err.toString()
        this.$dialog.alert({
          title: 'เกิดข้อผิดพลาด',
          message: this.error
        })
      } else if (chapter) {
        this.error = ''
        this.novel = this.$root.novels.find(novel => novel.id === this.novelId)
        this.$binding('comments', db.collection(`chapters/${this.novelId}-${chapter.chapter}/comments`))
        if (this.canRead(chapter)) {
          this.value = chapter
        } else if (this.isEmpty(this.user)) {
          this.$dialog.alert({
            title: 'ท่านไม่ได้เข้าสู่ระบบ!',
            message: 'กรุณาเข้าสู่ระบบหรือสมัครสมาชิกเพื่อตรวจสอบประวัติการสนับสนุนของท่าน',
            hasIcon: true,
            type: 'is-warning',
            confirmText: 'เข้าสู่ระบบ',
            onConfirm: () => { this.$router.push({ name: 'login' }) },
            canCancel: false
          })
        } else {
          this.$dialog.confirm({
            title: 'ระดับขั้นไม่เพียงพอ!',
            message: this.messageForRead(chapter),
            hasIcon: true,
            type: 'is-danger',
            confirmText: 'เพิ่มยอดสนับสนุน',
            onConfirm: () => { this.$router.push({ name: 'subscriptions', params: { initialSelectedNovel: this.novel } }) },
            cancelText: 'กลับสารบัญ',
            onCancel: () => { this.$router.push({ name: 'novel', params: { novelId: this.novelId } }) }
          })
        }
      }
      commit('SET_LOADING', false)
    },
    setApperance () {
      if (parseInt(this.chapterId) !== this.chapterNumber) {
        this.chapterNumber = parseInt(this.chapterId)
      }
      this.theme = localStorage.getItem('theme')
      this.themeIndex = parseInt(localStorage.getItem('themeIndex'))
      if (localStorage.getItem('contentFontSize') !== 'NaN') {
        this.fontSize = parseInt(localStorage.getItem('contentFontSize'))
      }
      this.contentStyle.fontSize = this.fontSize + 'px'
      this.appendReaded()
    },
    appendReaded () {
      var readed = localStorage.getItem('my_read')
      if (!readed) { readed = [] }
      if (readed.length > 0) { readed = readed.split(',') }
      if (readed.length >= 20) {
        readed.shift()
      }
      readed.push(this.$route.fullPath)
      localStorage.setItem('my_read', readed)
    },
    isEmpty (obj) {
      return Object.keys(obj).length === 0
    },
    postComment (comment, toComment) {
      this.isCommentLoading = true
      db.collection(`chapters/${this.novelId}-${this.chapterId}/comments`)
        .add({
          displayName: comment.displayName,
          text: comment.text,
          date: firebase.firestore.Timestamp.now(),
          uid: this.user.uid ? this.user.uid : null,
          photoURL: this.user.photoURL ? this.user.photoURL : null,
          nestedComment: toComment ? toComment['.key'] : null,
          hearts: []
        })
        .then((docRef) => {
          console.log(docRef)
          this.isCommentLoading = false
          this.myComment.text = ''
        })
        .catch(error => this.showPopup(`Error create comment: ${error.code}`))
    },
    removeComment (comment) {
      db.collection(`chapters/${this.novelId}-${this.chapterId}/comments`).doc(comment['.key'])
        .delete()
        .then(() => {
          this.$toast.open({ message: 'ลบข้อความสำเร็จ กรุณาโหลดหน้านี้อีกครั้ง' })
        })
        .catch(error => this.$toast.open({ message: `Error removing comment: ${error.code}` }))
    },
    showPopup (content) {
      this.isCommentLoading = false
      this.$toast.open({ message: content })
    },
    dateFromNow (date) {
      return moment(date.toDate()).fromNow()
    },
    toggleReply (comment) {
      if (this.isReplyingComment === comment['.key']) {
        this.isReplyingComment = ''
      } else {
        this.isReplyingComment = comment['.key']
      }
    },
    toggleHeart (comment) {
      if (!this.user) { return }
      if (!this.user.uid) { return }
      var alreadyHearted = comment.hearts.find(value => value === this.user.uid)
      if (alreadyHearted) { return }
      comment.hearts.push(this.user.uid)
      db.collection(`chapters/${this.novelId}-${this.chapterId}/comments`).doc(comment['.key'])
        .update({ hearts: comment.hearts })
        .then(() => {
          this.$toast.open({ message: 'เพิ่มหัวใจสำเร็จ!' })
        })
        .catch(error => this.$toast.open({ message: `Error comment: ${error.code}` }))
    }
  },
  mounted () {
    this.setApperance()
    if (this.user.displayName) {
      this.myComment.displayName = this.user.displayName
    }
  },
  watch: {
    '$route': 'setApperance',
    theme (newValue) {
      localStorage.setItem('theme', newValue)
    },
    themeIndex (newValue) {
      localStorage.setItem('themeIndex', newValue)
      switch (newValue) {
        case 0: this.theme = ''
          break
        case 1: this.theme = 'dark'
          break
        case 2: this.theme = 'grey'
          break
        case 3: this.theme = 'bright'
          break
        default:
          break
      }
    },
    fontSize (value) {
      localStorage.setItem('contentFontSize', value)
      this.contentStyle.fontSize = value + 'px'
    }
  }
}
</script>

<style lang="scss">
  .dark {
    background-color: #181818 !important;
    span {
      color: #b0b0b0 !important;
    }
  }
  .grey {
    background-color: #5a5a5c !important;
    span {
      color: #cecece !important;
    }
  }
  .bright {
    background-color: #f8f1e3 !important;
    span {
      color: #4f321c !important;
    }
  }
  .textarea {
    border: 1px solid !important;
  }
</style>
